import { Component } from 'react';

import './edit-profile-form.css';
import HomePlayInput from '../home-play-input';
import HomePlayFormErrorConsole from '../home-play-form-error-console';

import { validatePassword } from '../../../../services/utils/form';

import { editHomePlayer } from '../../../../modules/user_api';

class EditProfileForm extends Component {
  constructor(props) {
    super(props);
    const { player } = props;
    const homeUser = player.home_user;
    this.state = {
      submitting: false,
      editted_user: false,
      gotErrors: false,
      errors: [],
      formData: {
        first_name: homeUser.first_name,
        last_name: homeUser.last_name,
        login: homeUser.login,
        new_password: '',
      },
    };
  }

  updateFormData(inputName, newValue) {
    this.setState({ ...this.state, formData: { ...this.state.formData, [inputName]: newValue } });
  }

  validateForm(formData) {
    let gotErrors = false;
    const errors = [];
    const firstName = formData.first_name;
    const lastName = formData.last_name;
    const password = formData.new_password;
    const login = formData.login;

    if (login.length < 6) {
      gotErrors = true;
      errors.push('User name must be at least 6 characters long');
    }

    if (firstName.length < 2) {
      gotErrors = true;
      errors.push('First name must be at least 2 characters long');
    }

    if (lastName.length < 2) {
      gotErrors = true;
      errors.push('Last name must be at least 2 characters long');
    }

    if (password !== '' && validatePassword(password) === 'weak') {
      gotErrors = true;
      errors.push('Password too weak');
    }
    this.setState({ gotErrors: gotErrors, errors: errors });
    return !gotErrors;
  }

  cancelEdit() {
    this.setState({ cancelled: true });
  }

  editDone(user) {
    const { hide_func, update_home_user } = this.props;

    this.setState({ editted_user: user });
    update_home_user(user);
    hide_func();
  }

  async submitForm(e) {
    const { player } = this.props;
    e.preventDefault();
    const { formData, submitting } = this.state;

    if (submitting) {
      return;
    }

    this.setState({ submitting: true });

    const valid = this.validateForm(formData);

    if (!valid) {
      this.setState({ submitting: false });
      return;
    }

    const editResponse = await editHomePlayer(
      player.id,
      formData.first_name,
      formData.last_name,
      formData.login,
      formData.new_password
    );

    if (editResponse && editResponse.data) {
      const editData = editResponse.data;

      if (editData.success) {
        this.setState({ edit_done: true, submitting: false });
        const user = editData.user;
        setTimeout(() => {
          this.editDone(user);
        }, 800);
      } else {
        this.setState({ gotErrors: true, errors: editData.errors, submitting: false });
      }
    }
  }

  render() {
    const { player, show, hide_func } = this.props;
    const { submitting, edit_done, errors, gotErrors, editted_user } = this.state;
    let homeUser = player.home_user;
    if (editted_user) {
      homeUser = editted_user;
    }
    if (show) {
      return (
        <div className="edit_profile_form_dialog_container">
          <div className="edit_profile_form_modal" onClick={hide_func}></div>
          <div className="edit_profile_form_dialog">
            <button className="hide_edit_profile_form" onClick={hide_func}>
              <i className="fa fa-times"></i>
            </button>
            <div className="home_play_section_title">Edit Profile</div>
            <HomePlayFormErrorConsole show={gotErrors} errors={errors} />
            <div className="edit_profile_form">
              <HomePlayInput
                label="First Name"
                input_id="first_name"
                default_value={homeUser.first_name}
                updateForm={this.updateFormData.bind(this)}
                wide={true}
              />
              <HomePlayInput
                label="Last Name"
                input_id="last_name"
                default_value={homeUser.last_name}
                updateForm={this.updateFormData.bind(this)}
                wide={true}
              />
              <HomePlayInput
                label="Username"
                input_id="login"
                default_value={homeUser.login}
                updateForm={this.updateFormData.bind(this)}
                wide={true}
              />
              <HomePlayInput
                label="New Password (fill to change)"
                input_id="new_password"
                special_type="password"
                updateForm={this.updateFormData.bind(this)}
                wide={true}
              />
              {!submitting && (
                <button className="home_play_form_submit center" onClick={this.submitForm.bind(this)}>
                  Save
                </button>
              )}
              {submitting && (
                <div>
                  Working... <i className="fa fa-spin fa-spinner"></i>
                </div>
              )}
              {edit_done && (
                <div className="home_play_form_activated">
                  Edit Successful <i className="fa fa-check activation icon"></i>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return '';
    }
  }
}

export default EditProfileForm;
